<div class="">
  <p-table
    styleClass="risk-table-striped"
    [value]="integrations"
    *ngIf="integrations"
    dataKey="id"
    #integrationsTbl
    [tableStyle]="{ 'width': '100%' }"
  >
    <ng-template pTemplate="caption">
      <div class="flex align-items-center">
        <div class="">Integrations</div>
        <p-button
          icon="pi pi-plus"
          [outlined]="true"
          severity="secondary"
          class="ml-auto"
          (click)="editIntegration()"
          pTooltip="Create New"
        ></p-button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th class="font-bold white-space-nowrap">Integration</th>
        <th class="font-bold white-space-nowrap">Type</th>
        <th class="font-bold white-space-nowrap">Status</th>
        <th class="font-bold white-space-nowrap">Created</th>
        <th class="font-bold white-space-nowrap">Updated</th>
        <th style="width: 3rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-expanded="expanded">
      <tr>
        <td>
          <button
            type="button"
            pButton
            pRipple
            [pRowToggler]="item"
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          ></button>
        </td>
        <td>{{ item.name }}</td>
        <td>{{ item.type }}</td>
        <td>{{ item.status }}</td>
        <td>{{ item.createdDate | date : 'short' }}</td>
        <td>{{ item.updatedDate | date : 'short' }}</td>
        <td>
          <div class="flex align-items-center justify-content-center gap-1">
            <p-button
              [text]="true"
              icon="pi pi-play"
              (click)="test(item)"
              pTooltip="Test"
            ></p-button>
            <p-button
              [text]="true"
              icon="pi pi-pencil"
              (click)="editIntegration(item)"
              pTooltip="Edit"
            ></p-button>
            <p-button
              [text]="true"
              icon="pi pi-trash"
              severity="danger"
              (click)="deleteIntegration(item)"
              pTooltip="Delete"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="expandedrow" let-item>
      <tr>
        <td colspan="7">
          <p-table
            styleClass="risk-table-striped"
            [value]="item.logs"
            #table
            [tableStyle]="{ 'width': '100%' }"
          >
            <ng-template pTemplate="header">
              <tr class="font-bold white-space-nowrap">
                <th class="font-bold white-space-nowrap">Date</th>
                <th class="font-bold white-space-nowrap">Status</th>
                <th class="font-bold white-space-nowrap">Details</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-log>
              <tr>
                <td>{{ log.date | date : 'short' }}</td>
                <td>{{ log.status }}</td>
                <td>{{ log.details }}</td>
              </tr>
            </ng-template>
          </p-table>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
